export const multipleOfToDisplayValue = value => {
  var _String$split;
  return String(value) === '1' ? 0 : ((_String$split = String(value).split('.')) == null || (_String$split = _String$split[1]) == null ? void 0 : _String$split.length) || 0;
};
export const getMultipleOf = value => {
  if (Number(value) === 0) {
    return 1;
  }
  let newValue = 1;
  for (let i = 0; i < value; i++) {
    newValue = Number((newValue * 0.1).toFixed(value));
  }
  return newValue;
};
//# sourceMappingURL=decimal-setting-utils.js.map